import React from 'react'
import { Link } from 'react-router-dom'
import { translate } from 'react-i18next'

import Icon from '../../Global/Icon'

export default translate('common')(({ handleNavClick, t }) => (
  <div className="container">
    <div className="header__logo">
      <Link to={{
        pathname: '/',
        state: {
          to: 'home'
        }
      }} onClick={() => handleNavClick()}>
        <Icon className="icon icon-logo" icon="logo" />
      </Link>
    </div>
    <h1 className="header__title">{ t('header.title') }</h1>
  </div>
))



// WEBPACK FOOTER //
// ./src/components/Header/HeaderBody/HeaderBody.js